import { createBrowserRouter } from 'react-router-dom';
import Home from './pages/home';
import NewLightingControl from './pages/NewLightingControl';
import EnergyUseApplication from './pages/EnergyUseApplication';
import EnergyUsePlan from './pages/EnergyUsePlan';
import EnergyUseApplicationDetail from './pages/EnergyUseApplicationDetail';
import EnergyUseApplicationForm from './pages/EnergyUseApplicationForm';
import EnergyUseManagement from './pages/EnergyUseManagement';
import EnergyUsePlanList from './pages/EnergyUsePlanList';
import Detail from './pages/EnergyUsePlanList/Detail';
import EnergyOverview from './pages/EnergyOverview';
import AlarmRecord from './pages/AlarmRecord';
import AlarmRecordFilter from './pages/AlarmRecordFilter';
import { addPermissionByLoop, CreateRoutersProps } from '@maxtropy/components';
import AuthorizedPermission from './pages/AuthorizedPermission';
import { PermissionsType } from './common/permissionsConst';

const basename = process.env.NODE_ENV === 'production' ? '/mobile' : '';

const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/intelligent-platform',
    element: <Home />,
  },
  {
    path: '/intelligent-platform/energyOverview',
    permission: PermissionsType.P_ENERGYOVERVIEWMOBILE,
    element: <EnergyOverview />,
  },
  {
    path: '/intelligent-platform/energyUse/management',
    permission: PermissionsType.P_ENERGYUSAGELEDGERMOBILE,
    element: <EnergyUseManagement />,
  },
  {
    path: '/intelligent-platform/energyUse/plan',
    permission: PermissionsType.P_CANBEAPPLICEDMOBILE,
    element: <EnergyUsePlan />,
  },
  {
    path: '/intelligent-platform/energyUse/plan/:id',
    element: <EnergyUsePlan />,
  },
  {
    path: '/intelligent-platform/energyUse/plan/list',
    permission: PermissionsType.P_ENERGYUSEPLANNINGMOBILE,

    element: <EnergyUsePlanList />,
  },
  {
    path: '/intelligent-platform/energyUse/plan/detail/:id',
    element: <Detail />,
  },
  {
    path: '/intelligent-platform/energyUse/application',
    permission: PermissionsType.P_DELAYSCHEDULEMOBILE,

    element: <EnergyUseApplication />,
  },
  {
    path: '/intelligent-platform/energyUse/application/add',
    element: <EnergyUseApplicationForm />,
  },
  {
    path: '/intelligent-platform/energyUse/application/edit/:id',
    element: <EnergyUseApplicationForm />,
  },
  {
    path: '/intelligent-platform/energyUse/application/detail/:id',
    element: <EnergyUseApplicationDetail />,
  },
  {
    path: '/intelligent-platform/lighting/control',
    permission: PermissionsType.P_LIGHTINGCONTROLMOBILE,
    element: <NewLightingControl />,
  },
  {
    path: '/intelligent-platform/alarm/record',
    permission: PermissionsType.P_ALARMRECORDMOBILE,
    element: <AlarmRecord />,
  },
  {
    path: '/intelligent-platform/alarm/record/filter',
    element: <AlarmRecordFilter />,
  },
];

const createRouters = (parameters: CreateRoutersProps) => {
  const { routes, render } = parameters;
  const pagesRoutes = addPermissionByLoop({ routes, render });
  return createBrowserRouter(pagesRoutes, { basename });
};

const mobileRouters = createRouters({
  routes,
  render: (pers, ele) => {
    return <AuthorizedPermission permissionKey={pers}>{ele}</AuthorizedPermission>;
  },
});

export default mobileRouters;
